<template>
  <v-col cols="12" md="4">
    <div
      v-infinite-scroll="() => $emit('on-scroll')"
      :infinite-scroll-disabled="busy"
      class="message-group px-4"
      :style="{ height: windowHeight - 300 + 'px !important' }"
    >
      <v-row>
        <v-col v-for="(group, index) in messageGroups" :key="index" cols="12">
          <v-hover v-slot="{ hover }" open-delay="200">
            <v-card
              :class="{ 'on-hover': hover, selected: group.selected }"
              outlined
              @click="() => $emit('on-group-click', group)"
            >
              <v-card-text>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div style="width: 100%">
                      <span v-bind="attrs" v-on="on">
                        <div class="d-flex justify-space-between">
                          <CardStudentName :student="group.student" class="ml-n2" />
                          <v-icon v-if="group.hasUnreadMessage" color="#0d47a1">mdi_fiber_manual_record</v-icon>
                        </div>
                        <div class="truncate-text">
                          {{ group | getLastMessageContent }}
                        </div>
                      </span>
                    </div>
                  </template>
                  <span>{{ group | _get('student.name') }} - Lớp {{ group | _get('class.title', 'Không có') }}</span>
                </v-tooltip>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
        <v-col>
          <div v-if="busy">
            <v-skeleton-loader type="card-avatar, article" />
          </div>
        </v-col>
      </v-row>
    </div>
  </v-col>
</template>
<script>
import { get } from 'lodash'
import { mapGetters } from 'vuex'

import CardStudentName from '@/components/basic/card/CardStudentName.vue'

export default {
  components: { CardStudentName },
  props: {
    busy: Boolean,
    windowHeight: Number
  },
  computed: {
    ...mapGetters('Feedback', ['messageGroups'])
  },
  filters: {
    getLastMessageContent(messageGroup) {
      if (get(messageGroup, 'lastMessage.image')) return 'Đã gửi 1 ảnh'
      return get(messageGroup, 'lastMessage.content', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.message-group {
  overflow: auto;
}

.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.selected {
  background: lightsteelblue;
}

.on-hover {
  border: 1px solid #8ca8f7;
}
</style>
